import { Directive, HostListener, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appHoverEffectSidebar]'
})
export class HoverEffectSidebarDirective {
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);

  /** Inserted by Angular inject() migration for backwards compatibility */


  constructor() { }

  @HostListener('mouseover') onHover() {
    if (window.innerWidth > 768) {
      const element = this.document.querySelector('.sidenav-toggled');
      if (element) {
        this.renderer.addClass(element, 'sidenav-toggled-open');
      }
    }
  }

  @HostListener('mouseleave') onLeave() {
    if (window.innerWidth > 768) {
      const element = this.document.querySelector('.sidenav-toggled');
      if (element) {
        this.renderer.removeClass(element, 'sidenav-toggled-open');
      }
    }
  }
}
